<template>
  <Modal :closable="false">
    <div class="modal__shields">
      <ModalShield
        v-for="level in levels.length - 1"
        :key="level"
        :icon="
          levels[level].state === 'finish' ? 'prizeUnlocked' : 'prizeLocked'
        "
        :class="{ 'shield--active': levels[level].state === 'finish' }"
      />
      <ModalShield
        :icon="secretFound ? 'prizeUnlocked' : 'prizeLocked'"
        :class="['shield--secret', { 'shield--active': secretFound }]"
      />
    </div>

    <h1>Поражение!</h1>
    <p>Кажется, вы ошиблись. Ну, ничего!<br />Попробуйте еще раз.</p>

    <div class="modal__actions">
      <button
        class="button"
        data-size="big"
        @click="restartWithPixel(levelId)"
        :data-pixel="pixels.restart"
      >
        Еще раз
      </button>
    </div>

    <img src="../assets/img/divider.svg" class="modal__divider" />
    <p>А вы знали, что <span v-html="getRandomFact()" /></p>
  </Modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import Modal from "./Modal.vue";
import ModalShield from "./ModalShield.vue";
import getRandomFact from "../helpers/getRandomFact";

export default {
  data() {
    return {
      pixels: {
        levels: [
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jicxh&pr=%random%&ptrc=b",
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jicxj&pr=%random%&ptrc=b",
          "https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=dnchq&pfb=jicxi&pr=%random%&ptrc=b"
        ]
      },
      links: {
        gamesList:
          "https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=jhjcz&pr=%random%"
      }
    };
  },
  components: { Modal, ModalShield },
  computed: {
    ...mapState(["levelId", "levels"]),
    ...mapGetters(["secretFound"])
  },
  methods: {
    getRandomFact,
    ...mapActions(["restartLevel"]),
    restartWithPixel() {
      this.$metrika.showPixel(this.pixels.levels[this.levelId - 1]);
      this.restartLevel(this.levelId);
    }
  }
};
</script>

<style lang="scss" scoped></style>
